export default {
    grupoCaracteristicas: [
        {
            value: 'alergenos',
            text: 'Alergenos'
        },
        {
            value: 'vegano',
            text: 'Vegano / Celiaco'
        },
        {
            value: 'picante',
            text: 'Picante'
        },
    ],
    caracteristicasArray : []
}